export default class CACA1070RequestModel {
  productNo: string
  shhnCd: string
}
